export const ADD_SYSTEM_CONFIGURATION= "ADD_SYSTEM_CONFIGURATION"
export const GET_SYSTEM_CONFIGURATION = "GET_SYSTEM_CONFIGURATION"
export const ALL_SYSTEM_CONFIGURATION = "ALL_SYSTEM_CONFIGURATION"
export const EDIT_SYSTEM_CONFIGURATION = "EDIT_SYSTEM_CONFIGURATION"
export const UPLOAD_FILE = "UPLOAD_FILE"
export const DOWNLOAD_FILE = "DOWNLOAD_FILE"

